<script setup>
import { computed, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useLayoutStore } from "@/stores/layout";
import { useUserStore } from "@/stores/user";
import { getGradeintegral } from "@/api/tutordata";

const layoutStore = useLayoutStore();
const userStore = useUserStore();
const { levelDialog } = storeToRefs(layoutStore);

const visible = computed({
  get: () => !!levelDialog.value.dialog,
  set: (v) => {
    if (!v) layoutStore.closeLevelDialog();
    else layoutStore.openLevelDialog();
  },
});

const rows = ref([]);
const loading = ref(false);

function load() {
  loading.value = true;
  getGradeintegral()
    .then((res) => {
      if (res.data?.ErrorCode !== 0) {
        rows.value = [];
        return;
      }
      const body = res.data.Body || [];
      const score = Number(userStore.teachingPoints) || 0;
      const curr = body.filter((t) => t.ScoreStart <= score && t.ScoreEnd >= score);
      if (curr.length > 0) {
        userStore.setIntegralLevel(curr[0].GradeName);
      }
      const mid = Math.ceil(body.length / 2);
      const right = body.slice(mid).map((t) => ({
        level: t.GradeName,
        range: `${t.ScoreStart}-${t.ScoreEnd}`,
      }));
      rows.value = body.slice(0, mid).map((t, i) => ({
        level: t.GradeName,
        range: `${t.ScoreStart}-${t.ScoreEnd}`,
        level2: right[i]?.level || "",
        range2: right[i]?.range || "",
      }));
    })
    .catch(() => {
      rows.value = [];
    })
    .finally(() => {
      loading.value = false;
    });
}

watch(visible, (open) => {
  if (open) load();
});
</script>

<template>
  <el-dialog
    v-model="visible"
    title="Grade Integral"
    width="600px"
    class="level-dialog"
    align-center
  >
    <el-table
      v-loading="loading"
      :data="rows"
      :empty-text="loading ? 'Loading...' : 'No Data'"
      class="common-table"
    >
      <el-table-column label="Level" min-width="80">
        <template #default="{ row }">
          <span class="level-name">{{ row.level }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Range" prop="range" align="right" min-width="100" />
      <el-table-column label="Level" min-width="80">
        <template #default="{ row }">
          <span class="level-name">{{ row.level2 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Range" prop="range2" align="right" min-width="100" />
    </el-table>
  </el-dialog>
</template>

<style scoped lang="scss">
.level-name {
  color: $blue-title-2;
  font-weight: 700;
}
</style>
